import EmailReader from '@admin/components/email_reader'
import Panel from '@admin/components/panel'
import React from 'react'
import Send from './send'

const mapPropsToPanel = (props, context) => ({
  title: 't(Email)',
  component: <EmailReader contact={ props.contact } refresh={`/api/admin/crm/contacts/${props.contact.id}/emails`} />,
  tasks: {
    access: { rights: { $oneOf: ['crm:manage_contacts'] } },
    show: props.contact.deleted_at === null,
    items: [
      { 
        label: 't(Send Email Campaign)',
        svg: 'mail',
        modal: <Send contact={ props.contact } /> 
      }
    ]
  }
})

export default Panel(null, mapPropsToPanel)
